import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueResizeObserver from 'vue-resize-observer'

Vue.use(VueResizeObserver);
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
